import { isEmpty } from "lodash"
import { getQueryParameters, getIncludeNotHeldParameter, getSimulateActionsNode, getUsageParameters, getBetaInstrumentParameter, getContributorDescriptors, getAnalyticsOutputParameter } from "./helpers"
import { getBetaTypes } from "selectors/missingDataFiles"

export function betaQuery(missingDataFiles, options = {}) {
  const parameters = [getAnalyticsOutputParameter(options)]

  return `query (${getQueryParameters(parameters)}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode(parameters)} {
       ${betaQueryFragment(missingDataFiles)}
      }
    }
  }`
}

export function betaQueryFragment(missingDataFiles) {
  const betaTypes = getBetaTypes(missingDataFiles)
  return ` beta {
    date
    ${betaTypes}
  }`
}

export function betaContributorsQuery(missingDataFiles, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${betaContributorsQueryFragment(missingDataFiles, [includeNotHeldParameter])}
      }
    }
  }`
}

export function betaContributorsQueryFragment(missingDataFiles, parameters = []) {
  const betaTypes = getBetaTypes(missingDataFiles)

  return `betaContributors${getUsageParameters(parameters, true)} {
    date
    contributors {
      ${getContributorDescriptors()}
      ${betaTypes}
      ${!isEmpty(betaTypes) ? `securityBeta {
        ${betaTypes}
      }` : ""}
    }
  }`
}

export function dynamicBetaQuery(betaInstrument, options = {}) {
  const betaInstrumentParameter = getBetaInstrumentParameter(betaInstrument, options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, betaInstrumentParameter])}) {
    model(id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
        ${dynamicBetaQueryFragment(betaInstrument)}
      }
    }
  }`
}

export function dynamicBetaQueryFragment(betaInstrument) {
  if (!betaInstrument) { return "" }
  return `dynamicBeta: beta(instrument: $betaInstrument) {
    date
    dynamicPredicted: predicted
  }`
}

export function dynamicBetaContributorsQuery(betaInstrument, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const betaInstrumentParameter = getBetaInstrumentParameter(betaInstrument, options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, betaInstrumentParameter, includeNotHeldParameter])}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
       ${dynamicBetaContributorsQueryFragment(betaInstrument, [betaInstrumentParameter, includeNotHeldParameter])}
      }
    }
  }`
}

export function dynamicBetaContributorsQueryFragment(betaInstrument, parameters = []) {
  if (!betaInstrument) { return "" }
  return `dynamicBetaContributors: betaContributors${getUsageParameters(parameters, true)} {
    date
    contributors {
      ${getContributorDescriptors()}
      dynamicPredicted: predicted
      securityBeta {
        dynamicPredicted: predicted
      }
    }
  }`
}

export function groupedBetaContributorsQuery(missingDataFiles, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, includeNotHeldParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
       ${groupedBetaContributorsQueryFragment(missingDataFiles, [includeNotHeldParameter])}
      }
    }
  }`
}

export function groupedBetaContributorsQueryFragment(missingDataFiles, parameters = []) {
  const betaTypes = getBetaTypes(missingDataFiles)

  return `groupedBetaContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    groupedContributors {
      id
      name
      ${betaTypes}
      contributors{
        ${getContributorDescriptors()}
        ${betaTypes}
        ${!isEmpty(betaTypes) ? `securityBeta {
          ${betaTypes}
        }` : ""}
      }
    }
  }`
}

export function groupedDynamicBetaContributorsQuery(betaInstrument, options = {}) {
  const includeNotHeldParameter = getIncludeNotHeldParameter(options)
  const betaInstrumentParameter = getBetaInstrumentParameter(betaInstrument, options)
  const analyticsOutputParameter = getAnalyticsOutputParameter(options)
  return `query (${getQueryParameters([analyticsOutputParameter, betaInstrumentParameter, includeNotHeldParameter], true)}) {
    model (id: $modelId) {
      simulation: ${getSimulateActionsNode([analyticsOutputParameter])} {
       ${groupedDynamicBetaContributorsQueryFragment(betaInstrument, [betaInstrumentParameter, includeNotHeldParameter])}
      }
    }
  }`
}

export function groupedDynamicBetaContributorsQueryFragment(betaInstrument, parameters = []) {
  if (!betaInstrument) { return "" }
  return `groupedDynamicBetaContributors: groupedBetaContributors(groupBy: $groupBy, groupById: $groupById, classificationTier: $tier ${getUsageParameters(parameters)}) {
    date
    groupedContributors {
      id
      dynamicPredicted: predicted
      contributors{
        ${getContributorDescriptors()}
        dynamicPredicted: predicted
        securityBeta {
          dynamicPredicted: predicted
        }
      }
    }
  }`
}
